module.exports = {
    URL: 'https://suterh.imsarcs.intertronmobile.com',
    // URL: 'http://localhost:5001'
};